import type { FunctionComponent, Ref } from 'react';
import React, { useContext } from 'react';

import { RicosContext } from './../ricos-context';

import { IFRAME_COMPONENT } from './data-hooks';
import styles from './statics/styles/Iframe-scss';

const Iframe: FunctionComponent<{ iframeRef?: Ref<HTMLIFrameElement>; [key: string]: unknown }> = ({
  iframeRef,
  isViewer,
  ...otherProps
}) => {
  const { tabIndex } = useContext(RicosContext);

  return (
    <iframe
      ref={iframeRef}
      className={styles.iframe}
      title="remote content"
      data-hook={IFRAME_COMPONENT}
      style={{ backgroundColor: 'transparent' }}
      allow={isViewer ? 'fullscreen; autoplay; encrypted-media' : 'fullscreen; encrypted-media'}
      allowFullScreen
      {...otherProps}
      tabIndex={tabIndex}
    />
  );
};

export default Iframe;
